import { httpLastTickets, httpReadApi } from './http';
import gamesHeaders from './headers';

export default {
  getEndpoint(platformName) {
    const platform = platformName ? platformName.toUpperCase() : 'SEVEN';
    const path = `VUE_APP_${platform}_LASTTICKETS_PATH`;
    return process.env[path];
  },
  getLastTickets(config, user) {
    const { platformName } = config;
    let url = this.getEndpoint(platformName);
    if (platformName === 'NextGen') url = this.interpolateUrl(url, user.profile);

    const excludeStatusList = ['CLOSED', 'REJECTED', 'AFTERCLOSED'];

    const params = {
      count: 5,
      id_language: config.locale,
      notstatus: excludeStatusList.toString(),
      player: user.profile.username,
      product: config.productFqn,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const headers = {
      ...gamesHeaders.getAuthHeader(user, config),
      ...gamesHeaders.getNgsHeaders(config, user),
    };

    return httpLastTickets(config).get(url, { params, headers });
  },
  getLastTicketsFromReadApi(config, user) {
    const { productName, tenantId } = config;
    const { id, token } = user.profile;

    const headers = {
      authorization: `Bearer ${token}`,
      'X-Nsft-Games-Tenant-Id': tenantId,
      'X-Nsft-Games-Product-Name': productName,
    };

    const now = new Date();
    const dateTo = now.toISOString();

    const dateFrom = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() - 30,
        0, 0, 0, 0,
      ),
    ).toISOString();

    // Filter out cancelled and expired tickets, as they are not relevant for the last tickets view
    // TODO should update this when we get inPlay status.
    const statuses = 'Accepted,Won,Lost,Paidout';

    const params = {
      tenants: tenantId,
      products: productName,
      size: 5,
      page: 1,
      dateFrom,
      dateTo,
      statuses,
    };
    return httpReadApi().get(`tickets/players/${id}`, { headers, params });
  },
  // USED TO POPULATE VALUES INSIDE {} curly brackets in url
  interpolateUrl(url, config) {
    return url.replace(/{([^}]+)}/g, (match, key) => (Object.prototype.hasOwnProperty.call(config, key) ? config[key] : match));
  },
};
